import { ResourceDetails } from '../common';

export enum RdsAction {
  START = 'start',
  STOP = 'stop',
  RESTART = 'restart',
}

export type RdsActionType =
  | RdsAction.START
  | RdsAction.STOP
  | RdsAction.RESTART;

export enum RdsState {
  AVAILABLE = 'available',
  BACKING_UP = 'backing-up',
  CONFIGURING_ENHANCED_MONITORING = 'configuring-enhanced-monitoring',
  CONFIGURING_IAM_DATABASE_AUTH = 'configuring-iam-database-auth',
  CONFIGURING_LOG_EXPORTS = 'configuring-log-exports',
  CONVERTING_TO_VPC = 'converting-to-vpc',
  CREATING = 'creating',
  DELETE_PRECHECK = 'delete-precheck',
  DELETING = 'deleting',
  FAILED = 'failed',
  INACCESSIBLE_ENCRYPTION_CREDENTIALS = 'inaccessible-encryption-credentials',
  INACCESSIBLE_ENCRYPTION_CREDENTIALS_RECOVERABLE = 'inaccessible-encryption-credentials-recoverable',
  INCOMPATIBLE_CREATE = 'incompatible-create',
  INCOMPATIBLE_NETWORK = 'incompatible-network',
  INCOMPATIBLE_OPTION_GROUP = 'incompatible-option-group',
  INCOMPATIBLE_PARAMETERS = 'incompatible-parameters',
  INCOMPATIBLE_RESTORE = 'incompatible-restore',
  INSUFFICIENT_CAPACITY = 'insufficient-capacity',
  MAINTENANCE = 'maintenance',
  MODIFYING = 'modifying',
  MOVING_TO_VPC = 'moving-to-vpc',
  REBOOTING = 'rebooting',
  RESETTING_MASTER_CREDENTIALS = 'resetting-master-credentials',
  RENAMING = 'renaming',
  RESTORE_ERROR = 'restore-error',
  STARTING = 'starting',
  STOPPED = 'stopped',
  STOPPING = 'stopping',
  STORAGE_CONFIG_UPGRADE = 'storage-config-upgrade',
  STORAGE_FULL = 'storage-full',
  STORAGE_INITIALIZATION = 'storage-initialization',
  STORAGE_OPTIMIZATION = 'storage-optimization',
  UPGRADING = 'upgrading',
  UPGRADE_FAILED = 'upgrade_failed',
  UNKNOWN = 'unknown',
}

// TODO: Add more column needed
export interface RdsResourceDetails extends ResourceDetails {
  status: RdsState;
  engine: string;
  class: string;
}
